import initSpecialtyPage from '../../components/specialty-page-init.js';

// Initialize event modal functionality for upcoming events section
import '../../components/event-modal-init.js';

initSpecialtyPage();
